import generateRequest from './services/request';
import generateJavaRequest from './services/jrequest';

const request = generateRequest('Crowdfund');
const jrequest = generateJavaRequest('crowdfund');

// 众筹信息
export function crowdfundInfo(id) {
  return jrequest('info', { id });
}

// 查看是否关注
export function crowdFollowInfo(id) {
  return jrequest('followInfo', { id });
}

// 取关、关注
export function followCrowdfundInfo(id, follow) {
  return jrequest('follow', { id, follow });
}

// 众筹档位列表
export function crowdfundLadderList(id) {
  return jrequest('ladderList', { id });
}

// 众筹关注列表
export function crowdfollowLadderList(conditions) {
  return jrequest('followList', conditions);
}

// 加入众筹列表
export function crowdJoinLadderList(conditions) {
  return jrequest('joinList', conditions);
}

// 查询订单价格
export function crowdPrice(ladder_id, goods_num) {
  return request('cart', { ladder_id, goods_num });
}

// 查询订单价格+邮费
export function crowdPriceWithAddress(address_id, ladder_id, goods_num) {
  return request('cart', { address_id, ladder_id, goods_num });
}

// 订单支付
export function crowdPay(conditions) {
  return request('cart', conditions);
}

// 查看众筹评论列表
export function crowdComments(conditions) {
  return jrequest('comments', conditions);
}

// 众筹支付后是否分享
export function crowdShare(conditions) {
  return jrequest('share', conditions);
}

